import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'wifi-0', 'Wifi0', [["path",{"d":"M12 18l.01 0"}]]);